import script from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./TodoManagement.vue?vue&type=script&setup=true&lang=js"

import "./TodoManagement.vue?vue&type=style&index=0&id=e3a4118a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3a4118a"]])

export default __exports__